// extracted by mini-css-extract-plugin
export var header = "Header-module--header--357cc";
export var fixed = "Header-module--fixed--39e53";
export var logo = "Header-module--logo--edb3a";
export var active = "Header-module--active--43916";
export var button = "Header-module--button--2246f";
export var layout = "Header-module--layout--499ea";
export var logos = "Header-module--logos--fdb79";
export var logoWrap = "Header-module--logoWrap--e3ae4";
export var secondLogo = "Header-module--secondLogo--8db62";
export var hideOnDesktop = "Header-module--hideOnDesktop--d05a3";
export var hideOnMobile = "Header-module--hideOnMobile--4a7b1";
export var navigation = "Header-module--navigation--acbc9";
export var touchPanel = "Header-module--touchPanel--5457b";